// Vendor Libraries
import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// Redux Actions
import {lockRecord, unlockRecord} from '../../actions/record-locking-actions';

class RecordLocker extends Component {
  componentWillMount() {
    this.setLockedRecords();
  }

  componentWillReceiveProps(nextProps) {
    const {recordId} = this.props;
    const {recordId: nextRecordId} = nextProps;

    if (nextRecordId !== recordId || (!nextRecordId && recordId)) {
      this.setLockedRecords(nextProps);
    }
  }

  componentWillUnmount() {
    const {recordId, serviceKey, unlockRecord} = this.props;

    unlockRecord(serviceKey, 'recordLocker', recordId);
  }

  setLockedRecords(props = this.props) {
    const {recordId, serviceKey} = props;
    const {lockRecord} = this.props;

    lockRecord(serviceKey, 'recordLocker', recordId);
  }

  render() {
    return null;
  }
}

RecordLocker.propTypes = {
  lockRecord: PropTypes.func.isRequired,
  recordId: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  serviceKey: PropTypes.string.isRequired,
  unlockRecord: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  lockRecord,
  unlockRecord,
};

export default connect(null, mapDispatchToProps)(RecordLocker);
